import { gql } from 'urql';

export const Q_LIQUIDACIONES_CHOFER = gql`
  query LiquidacionesChofer($sucursal_id: Int!, $chofer_id: Int, $desde: String, $hasta: String, $estado: EstadoLiquidacionChofer) {
    liquidacionesChofer(sucursal_id: $sucursal_id, chofer_id: $chofer_id, desde: $desde, hasta: $hasta, estado: $estado) {
      id
      sucursal_id
      chofer_id
      periodo_desde
      periodo_hasta
      estado
      total_km
      total_horas
      total_dias
      total_entregas
      subtotal
      adicionales
      descuentos
      total
      created_at
    }
  }
`;

export const Q_LIQUIDACION_DETALLE = gql`
  query LiquidacionDetalle($id: Int!) {
    liquidacionDetalle(id: $id) {
      id
      sucursal_id
      chofer_id
      periodo_desde
      periodo_hasta
      estado
      total_km
      total_horas
      total_dias
      total_entregas
      subtotal
      adicionales
      descuentos
      total
      notas
      snapshot_tarifas_json
      items {
        id
        referencia_tipo
        referencia_id
        fecha
        km
        horas
        entregas
        monto
      }
    }
  }
`;

export const M_GENERAR_LIQUIDACION_CHOFER = gql`
  mutation GenerarLiquidacionChofer($input: GenerarLiquidacionChoferInput!) {
    generarLiquidacionChofer(input: $input) {
      id
      estado
      total
    }
  }
`;

export const M_AJUSTAR_LIQUIDACION_CHOFER = gql`
  mutation AjustarLiquidacionChofer($input: AjustarLiquidacionChoferInput!) {
    ajustarLiquidacion(input: $input) {
      id
      adicionales
      descuentos
      notas
      total
    }
  }
`;

export const M_CERRAR_LIQUIDACION_CHOFER = gql`
  mutation CerrarLiquidacionChofer($id: Int!, $notas: String) {
    cerrarLiquidacion(id: $id, notas: $notas)
  }
`;

export const M_MARCAR_PAGADA_LIQUIDACION_CHOFER = gql`
  mutation MarcarPagadaLiquidacionChofer($id: Int!) {
    marcarLiquidacionPagada(id: $id)
  }
`;
